import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { DatesProvider } from '@mantine/dates';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { App } from './App.tsx';
import { theme } from './theme.ts';

dayjs.extend(utc);
dayjs.extend(timezone);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('root element missing from index.html');
}

// Timezone is derived from the active venue profile at runtime (see
// StaffProfileProvider in App.tsx). Before the profile resolves, DatesProvider
// has no timezone override — the loading shell doesn't need one.
createRoot(rootElement).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <DatesProvider settings={{ locale: 'zh-tw' }}>
        <Notifications position="top-right" />
        <App />
      </DatesProvider>
    </MantineProvider>
  </StrictMode>,
);
